module.exports = __webpack_public_path__ + "img/festival-midia-festival.2a0f705a.png";